// Module
var code = "<react-component name=\"PendingCancellationsReport\"></react-component>\n";
// Exports
module.exports = code;